const CONTROL_TOKENS = {
  ERROR: "[[__ERROR__]]",
  STOP: "[[__STOP__]]",
  BREAK: "[[__BREAK__]]",
  END: "[[__END__]]",
}

const COMPLETED_TOKENS = new Set([
  CONTROL_TOKENS.STOP,
  CONTROL_TOKENS.BREAK,
  CONTROL_TOKENS.END,
])

/// This regex is to be used for splitting chunks while streaming only.

const TOKEN_REGEX = /\[\[__(STOP|BREAK|END|ERROR)__\]\]/g

export { COMPLETED_TOKENS, CONTROL_TOKENS, TOKEN_REGEX }
